import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { InformationalScreen, Stack } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useApiError, useAuth, useClickContinueEmailVerificationButton, useResendVerificationEmail, } from 'Hooks';
import { Footer, MainContainer, TopHeaderBackArrow } from 'Components/utility';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { signIn } from 'Services/auth';
import CheckYourEmailComponents from './components';
const mapStateToProps = ({ auth: { account_id }, env: { deviceId, installationId, osType, osVersion, app, appVersion, appHash }, }) => {
    return { account_id, deviceId, installationId, osType, osVersion, app, appVersion, appHash };
};
const connector = connect(mapStateToProps);
const CheckYourEmail = ({ data: { password, email }, deviceId, installationId, osType, osVersion, app, appVersion, appHash, account_id, }) => {
    const { showApiErrorModal, showNetworkErrorModal } = useApiError();
    const { showCountryRegionError } = useAuth();
    useEffect(() => {
        if (!password || !email) {
            mediator.publish('router:navigate', '/login');
        }
    }, [email, password]);
    const handleGoBack = () => {
        mediator.publish('router:back');
    };
    const handleApiRequestError = useCallback((error) => {
        switch (error.status) {
            case ApiStatus.BAD_REQUEST: {
                const code = error.response?.data.code;
                if (code === ApiStatus.UNSUPPORTED_COUNTRY || code === ApiStatus.WRONG_REGION) {
                    showCountryRegionError();
                    return;
                }
                break;
            }
            default:
                error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
        }
    }, [showApiErrorModal, showCountryRegionError, showNetworkErrorModal]);
    const signInFunction = useCallback(async () => {
        const authSession = await signIn({
            email,
            password: password.trim(),
            osType,
            osVersion,
            app,
            appVersion,
            deviceId,
            installationId,
            appHash,
        });
        notifyApp('adc-webview:signin', authSession);
    }, [email, password, osType, osVersion, app, appVersion, deviceId, installationId, appHash]);
    const { handleResendEmailButtonClick } = useResendVerificationEmail({
        account_id,
        osType,
        osVersion,
        app,
        appVersion,
        handleApiRequestError,
    });
    const { handleContinueEmailVerificationButtonClick } = useClickContinueEmailVerificationButton({
        account_id,
        osType,
        osVersion,
        app,
        appVersion,
        installationId,
        handleApiRequestError,
        signInFunction,
    });
    return (React.createElement(MainContainer, null,
        React.createElement(InformationalScreen, { topNavigationProps: {
                title: i18n.t('CheckYourEmailRegistration.title'),
                animatedTitle: true,
                buttonStart: {
                    element: React.createElement(TopHeaderBackArrow, { testID: "Auth.action-go-back" }),
                    onPress: handleGoBack,
                },
            }, testID: "CheckYourEmail" },
            React.createElement(InformationalScreen.Page, null,
                React.createElement(InformationalScreen.Content, null,
                    React.createElement(Stack, { marginTop: -8 },
                        React.createElement(CheckYourEmailComponents.Content, { email: email, onButtonPress: handleResendEmailButtonClick }))),
                React.createElement(InformationalScreen.Footer, null,
                    React.createElement(Footer, { buttonLabel: i18n.t('Global.microcopy.common.continue'), onButtonPress: handleContinueEmailVerificationButtonClick, buttonTestID: "CheckYourEmailRegistration.continueButton" }))))));
};
export default connector(CheckYourEmail);
